var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFeaturesServiceAna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 22,
    viewBox: "0 0 67 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_features_service_ana_svg__clip0_301_13349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.77 4a4 4 0 014-4h57.267a4 4 0 014 4v14a4 4 0 01-4 4H4.77a4 4 0 01-4-4V4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.385 3.667l-8.52 14.52h2.985l8.52-14.52h-2.985z",
    fill: "#00ADE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.949 8.383l.46 5.628c.023.29-.121.387-.412.387h-3.333l-1.063 1.932h4.469c.435 0 .58.29.604.629l.096 1.228h3.213L39.872 5.543H35.62l-6.643 12.644h2.15l5.17-9.828c.216-.386.627-.265.65.024zM13.298 13.94l-.359-5.677c-.024-.363-.362-.411-.604-.025l-5.749 9.95h-2.15l7.199-12.645h4.251l.894 12.644h-3.213l-.08-1.25c0-.288-.113-.607-.548-.607H8.181l1.062-1.932h3.624c.41 0 .431-.165.431-.457zM20.901 8.522l-1.77 9.665h-1.948l2.31-12.644h4.444l2.657 9.765c.113.314.467.298.516-.008l1.763-9.757h1.957l-2.287 12.644h-4.445l-2.66-9.683c-.087-.296-.482-.299-.537.018zM50.865 18.187l8.52-14.52h-8.956l-8.52 14.52h8.956z",
    fill: "#313C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_features_service_ana_svg__clip0_301_13349"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.77)",
    d: "M0 0h66v22H0z"
  })))));
}

export default SvgIconFeaturesServiceAna;